export const Weight = {
  Small: 'pet-weight-small',
  Medium: 'pet-weight-medium',
  Large: 'pet-weight-large',
  XL: 'pet-weight-xl',
  BackBtn: 'back-btn',
} as const;
